<template>
  <div class="spinner"></div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style scoped>
.spinner {
  border: 5px solid rgba(255, 255, 255, 0.3); /* Couleur de fond */
  border-top: 5px solid #3498db; /* Couleur de la bordure supérieure */
  border-radius: 50%; /* Rendre le div circulaire */
  width: 80px; /* Largeur du spinner */
  height: 80px; /* Hauteur du spinner */
  animation: spin 1s linear infinite; /* Animation nommée spin */
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* Départ de l'animation */
  }
  100% {
    transform: rotate(360deg); /* Fin de l'animation */
  }
}
</style>
